import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Map, Loader2 } from 'lucide-react';
import '../SellerAssistant/SellerAssistantMessageList.css';
import './OperationalAssistantMessageList.css';

function renderMessageContent(content, navigate) {
  if (!content) return null;

  const lines = String(content).split('\n');

  return lines.map((line, lineIndex) => {
    const parts = [];
    const linkRegex = /\[([^\]]+)\]\((\/erp\/[^)]+)\)/g;
    let lastIndex = 0;
    let match = linkRegex.exec(line);

    while (match) {
      if (match.index > lastIndex) {
        parts.push(line.slice(lastIndex, match.index));
      }
      const linkLabel = match[1];
      const linkHref = match[2];
      parts.push(
        <button
          key={`${lineIndex}-${match.index}`}
          type="button"
          className="operational-assistant-link"
          onClick={() => navigate(linkHref)}
        >
          {linkLabel}
        </button>
      );
      lastIndex = linkRegex.lastIndex;
      match = linkRegex.exec(line);
    }

    if (lastIndex < line.length) {
      parts.push(line.slice(lastIndex));
    }

    return (
      <p key={lineIndex} className="operational-assistant-message-line">
        {parts.length ? parts : '\u00A0'}
      </p>
    );
  });
}

function OperationalAssistantMessageList({ messages, loading, waitingResponse }) {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, loading, waitingResponse]);

  if (loading) {
    return (
      <div className="seller-assistant-messages seller-assistant-messages-loading">
        <Loader2 size={24} className="seller-assistant-spinner" />
        <span>Carregando conversa...</span>
      </div>
    );
  }

  if (!messages.length && !waitingResponse) {
    return (
      <div className="seller-assistant-messages seller-assistant-messages-empty operational-assistant-welcome">
        <div className="seller-assistant-welcome-icon operational-assistant-welcome-icon">
          <Map size={32} />
        </div>
        <h4>Assistente Operacional Pró Médico</h4>
        <p>
          Pergunte como usar o ERP: cadastros, compras, estoque, vendas e rotinas do dia a dia.
          Eu busco o passo a passo no mapa oficial do sistema.
        </p>
      </div>
    );
  }

  return (
    <div ref={scrollRef} className="seller-assistant-messages">
      {messages.map((msg) => {
        const isUser = msg.role === 'user';

        return (
          <div
            key={msg.id || `${msg.role}-${msg.created_at}`}
            className={`seller-assistant-message ${
              isUser ? 'seller-assistant-message-user' : 'seller-assistant-message-assistant'
            }`}
          >
            {!isUser && (
              <div className="seller-assistant-message-avatar operational-assistant-message-avatar">
                <Map size={14} />
              </div>
            )}
            <div className="seller-assistant-message-body">
              <div
                className={`seller-assistant-message-bubble ${
                  isUser
                    ? 'seller-assistant-message-bubble-user'
                    : 'seller-assistant-message-bubble-assistant operational-assistant-message-bubble'
                }`}
              >
                {isUser ? msg.content : renderMessageContent(msg.content, navigate)}
              </div>
            </div>
          </div>
        );
      })}

      {waitingResponse && (
        <div className="seller-assistant-message seller-assistant-message-assistant">
          <div className="seller-assistant-message-avatar operational-assistant-message-avatar">
            <Map size={14} />
          </div>
          <div className="seller-assistant-message-body">
            <div className="seller-assistant-message-bubble seller-assistant-message-bubble-assistant operational-assistant-typing">
              <Loader2 size={16} className="seller-assistant-spinner" />
              <span>Consultando o mapa do ERP...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OperationalAssistantMessageList;
